// 🔧 B256 (AI_115) — Minimiza os dados do paciente para o CRUZAMENTO da Etapa 2.
// ─────────────────────────────────────────────────────────────────────────────
// A Etapa 2 (self-reflection) reenvia os dados do paciente como `blocoValidacao`
// só para CONFERIR números/datas/medidas contra o texto da análise da Etapa 1.
// Em paciente com muito dado (ex.: 10 exames de imagem), os campos de TEXTO LONGO
// (laudos de imagem/evoluções por extenso) são o grosso dos tokens — e a Etapa 1
// JÁ os leu/interpretou. Aqui truncamos APENAS strings longas, **mantendo começo
// E fim** (achados ficam no começo; impressão/LI-RADS/medidas-chave no fim do
// laudo), e preservando INTACTOS números e campos estruturados curtos.
//
// NÃO altera os dados da Etapa 1 (que recebe o conjunto completo formatado).
// Função PURA → testável. Reduz custo+latência da Etapa 2 sem perder a âncora
// numérica que a auto-revisão precisa para pegar valor/data inventados.

export const MAX_TEXTO_CRUZAMENTO = 1500;

// Trunca preservando os primeiros 60% e os últimos 40% (achados + impressão).
function truncarComMeioOmitido(s: string, maxLen: number): string {
  if (s.length <= maxLen) return s;
  const head = Math.floor(maxLen * 0.6);
  const tail = maxLen - head;
  return (
    s.slice(0, head) +
    " …[trecho intermediário omitido p/ conferência]… " +
    s.slice(s.length - tail)
  );
}

export function minimizarDadosParaCruzamento(
  valor: any,
  maxLen: number = MAX_TEXTO_CRUZAMENTO
): any {
  if (typeof valor === "string") {
    return valor.length > maxLen ? truncarComMeioOmitido(valor, maxLen) : valor;
  }
  if (Array.isArray(valor)) {
    return valor.map((v) => minimizarDadosParaCruzamento(v, maxLen));
  }
  if (valor && typeof valor === "object") {
    const out: Record<string, any> = {};
    for (const k of Object.keys(valor)) {
      out[k] = minimizarDadosParaCruzamento(valor[k], maxLen);
    }
    return out;
  }
  return valor; // number, boolean, null, undefined — intactos
}
